// extracted by mini-css-extract-plugin
export default {"headerStyle":"headerComponent_headerStyle__FZ9IS","logoMegacable":"headerComponent_logoMegacable__Jf4kq"};